import React from 'react';
import PropTypes from "prop-types";
import { Tooltip } from 'antd';
import pencil from '../../assets/icons/edit.svg';
import pencil_disable from '../../assets/icons/edit_disable.svg';
import downCaret from "../../assets/icons/short-arrow-b.svg";
import { CSREditButton, EditIcon, GhostBackButtonWrapper, GhostButtonWrapper, LinkNavigatorWrapper, PrimaryButtonWrapper, RoundWrapper, ShowMoreWrapper, EditButtonWrap } from './styles';
import { CapsuleButton } from "../Commons/commonComponents";

const ArrowBtn = props => {
  return(
    <span>
      {!props.leftArrow && props.cta}
      <span className="new_arrow">
        <span className="arrow_line">
          <span></span>
        </span>
      </span>
      {props.leftArrow && props.cta}
    </span>
  )
}

ArrowBtn.propTypes = {
  cta: PropTypes.any,
  leftArrow: PropTypes.any
}

export const PrimaryButton =  (props)=> {
  const { buttonName, text, disabled, clicked, styling, htmlType, } = props;
  return (
    <div className={`${styling}`}>
      {disabled === true ? (
        <Tooltip
          placement={props.placement ? props.placement : 'right'}
          title={text}
        >
          <PrimaryButtonWrapper disabled={disabled} onClick={clicked} id={(props && props.id) && props.id} >
            <ArrowBtn cta={buttonName} />
          </PrimaryButtonWrapper>
        </Tooltip>
      ) : (
          <PrimaryButtonWrapper
            id={(props && props.id) && props.id}
            data-test='primaryBtnClick'
            disabled={disabled}
            onClick={clicked}
            htmlType={htmlType}
          >
            <ArrowBtn cta={buttonName} />
          </PrimaryButtonWrapper>
        )}
    </div>
  );
};

PrimaryButton.propTypes = {
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  htmlType: PropTypes.string,
  id: PropTypes.any,
  placement: PropTypes.string,
  styling: PropTypes.object,
  text: PropTypes.string
}

export const PrimaryButtonWithDisabled =  (props)=> {
  const { buttonName, text, disabled, clicked, styling, htmlType, width, id } = props;
  return (
    <div className={`${styling}`}>
      <PrimaryButtonWrapper
        id={(props && props.id) && props.id}
        width={width}
        disabled={disabled}
        onClick={clicked}
        htmlType={htmlType}
        color={disabled && '#505050' }
      >
        <ArrowBtn cta={buttonName} />
      </PrimaryButtonWrapper>
    </div>
  );
};

PrimaryButtonWithDisabled.propTypes = {
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  htmlType: PropTypes.string,
  id: PropTypes.string,
  styling: PropTypes.object,
  text: PropTypes.string,
  width: PropTypes.any
}

export const GhostButton = (props)=> {
  const { buttonName, htmlType, styling,id } = props;
  return (
    <div className={`${styling}`}>
      <GhostButtonWrapper
        id={(props && props.id) && props.id}
        disabled={props.disabled}
        onClick={props.clicked}
        htmlType={htmlType}
        id={id}
      >
        <ArrowBtn cta={buttonName} />
      </GhostButtonWrapper>
    </div>
  );
};

GhostButton.propTypes = {
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  htmlType: PropTypes.string,
  id: PropTypes.string,
  styling: PropTypes.object
}

export const GhostBackButton = (props)=> {
  const { buttonName, htmlType, styling } = props;
  return (
    <>
      <GhostBackButtonWrapper
        id={(props && props.id) && props.id}
        style={styling}
        disabled={props.disabled}
        onClick={props.clicked}
        htmlType={htmlType}
      >
        <span>{buttonName}</span>
      </GhostBackButtonWrapper>
    </>
  );
};

GhostBackButton.propTypes = {
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  htmlType: PropTypes.string,
  id: PropTypes.string,
  styling: PropTypes.object
}

export const LinkNavigatorButton = (props)=> {
  const { buttonName, styling, tabNavigation,id } = props;
  return (
    <LinkNavigatorWrapper
      id={(props && props.id) && props.id}
      disabled={props.disabled}
      onClick={props.clicked}
      className={`${styling}`}
      tabRedirect={props.tabRedirect}
      tabNavigation={tabNavigation}
      color="#006778"
    >
      <ArrowBtn cta={buttonName} />
    </LinkNavigatorWrapper>
  );
};

LinkNavigatorButton.propTypes = {
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  styling: PropTypes.object,
  tabNavigation: PropTypes.any,
  tabRedirect: PropTypes.any
}

/**
 * Returns edit button wrapped inside div.
 * 
 * @param {string} buttonName Pass button name as a string.
 * @param {boolean} boldFont For changing button font family to bold or medium.
 */
export const EditButtonComponent = (props)=> {
  const { className, buttonName, boldFont=true} = props;
  return (
    <EditButtonWrap className={className} boldFont={boldFont}>
      <CapsuleButton
        text = {buttonName}
        onClick = {props.clicked}
        disabled = {props.disabled}
        iconType = 'edit'
        id = {(props && props.id) && props.id}
      />
    </EditButtonWrap>
  );
};

EditButtonComponent.propTypes = {
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  htmlType: PropTypes.string,
  id: PropTypes.string,
  mediumFont: PropTypes.bool,
  styling: PropTypes.any
}

export const CSREditButtonComponent = (props)=> {
  const { styling, buttonName, htmlType } = props;
  return (
    <div className={`${styling}`}>
      <CSREditButton
        data-test="csrEditButton"
        id={(props && props.id) && props.id}
        disabled={props.disabled}
        onClick={props.clicked}
        htmlType={htmlType}
      >
        <span>{buttonName}</span>
        <EditIcon>
          <img src={props.disabled ? pencil_disable : pencil}  alt={props.disabled ? "Disabled edit": "Edit"} />
        </EditIcon>
      </CSREditButton>
    </div>
  );
};

CSREditButtonComponent.propTypes = {
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  htmlType: PropTypes.string,
  id: PropTypes.string,
  styling: PropTypes.object
}

export const PrimaryBackButton = (props)=> {
  const { buttonName, text, clicked, styling, customStyle, ShowArrow, id } = props;
  return (
    <div className={`${styling}`}>
      <PrimaryButtonWrapper leftArrow onClick={clicked} style={customStyle} id={(props && props.id) && props.id}>
        {ShowArrow === false ? null : (
          <ArrowBtn cta={buttonName} leftArrow />
        )}
      </PrimaryButtonWrapper>
    </div>
  );
};

PrimaryBackButton.propTypes = {
  ShowArrow: PropTypes.bool,
  buttonName: PropTypes.any,
  clicked: PropTypes.func,
  customStyle: PropTypes.object,
  id: PropTypes.string,
  styling: PropTypes.object,
  text: PropTypes.string
}

export const RoundButton = props => (
  <RoundWrapper onClick={props.buttonHandle} id={(props && props.id) && props.id}>
    <span>{props.buttonName}</span>
    <img src={props.image} alt={props.alt} />
  </RoundWrapper>
);

RoundButton.propTypes = {
  alt: PropTypes.string,
  buttonHandle: PropTypes.func,
  buttonName: PropTypes.any,
  id: PropTypes.string,
  image: PropTypes.string
}

export const RoundButtonDisabled = props => (
  <RoundWrapper onClick={props.buttonHandle} className='disabled_button' id={(props && props.id) ? props.id: "btnRoundButtonDisabled"}>
    <span >{props.buttonName}</span>
    <img src={props.image} alt={props.alt} />
  </RoundWrapper>
);

RoundButtonDisabled.propTypes = {
  alt: PropTypes.string,
  buttonHandle: PropTypes.func,
  buttonName: PropTypes.any,
  id: PropTypes.string,
  image: PropTypes.string
}

export const ShowMoreButton = props => {
  const { reverse } = props;
  return reverse ? (
    <ShowMoreWrapper>
      <CapsuleButton 
        text='Show less'
        onClick={props.buttonHandle}
        iconType='arrowUp'
        id={(props && props.id) && props.id}
        whiteBackground={true} 
      />
    </ShowMoreWrapper>
  ) : (
      <ShowMoreWrapper>
        <CapsuleButton 
          text='Show More'
          onClick={props.buttonHandle}
          iconType='arrowDown'
          whiteBackground={true} 
        />
      </ShowMoreWrapper>
    );
};
ShowMoreButton.propTypes = {
  buttonHandle: PropTypes.func,
  id: PropTypes.string,
  reverse: PropTypes.bool
}
